import {PropsWithChildren, useContext, useState} from "react";

import Button from "@/components/button/Button.tsx";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {ImportSubscribersModal} from "@/pages/statuspages/tabs/subscribers/components/import-subscribers/ImportSubscribersModal.tsx";

export interface StatusPageSubscribersImportActionButtonProps extends PropsWithChildren {
  className?: string;
}

export const StatusPageSubscribersImportActionButton = ({
  children,
  className,
}: StatusPageSubscribersImportActionButtonProps) => {
  const {statusPage} = useContext(StatusPageContext);

  const [show, setShow] = useState(false);
  return (
    <>
      <Button variant={"secondary"} className={className} onClick={() => setShow(true)}>
        {children}
      </Button>
      <ImportSubscribersModal show={show} statusPageID={statusPage.id} setShow={setShow} />
    </>
  );
};
